/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TicketRefundRequest
 */
export interface TicketRefundRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketRefundRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the TicketRefundRequest interface.
 */
export function instanceOfTicketRefundRequest(value: object): value is TicketRefundRequest {
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function TicketRefundRequestFromJSON(json: any): TicketRefundRequest {
    return TicketRefundRequestFromJSONTyped(json, false);
}

export function TicketRefundRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketRefundRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function TicketRefundRequestToJSON(json: any): TicketRefundRequest {
    return TicketRefundRequestToJSONTyped(json, false);
}

export function TicketRefundRequestToJSONTyped(value?: TicketRefundRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

